/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Select_RequiredInputs */

const en_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a preset`)
};

const fr_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un préréglage`)
};

const de_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Voreinstellung aus.`)
};

const it_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset`)
};

const ru_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите предустановку`)
};

const es_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un ajuste preestablecido`)
};

const zh_cn2_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择预设值`)
};

const ja_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択してください`)
};

const hi_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक प्रीसेट चुनें`)
};

const pt_pt2_audio_description_export_preset_select_required = /** @type {(inputs: Audio_Description_Export_Preset_Select_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione uma predefinição.`)
};

/**
* | output |
* | --- |
* | "Please select a preset" |
*
* @param {Audio_Description_Export_Preset_Select_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_select_required = /** @type {((inputs?: Audio_Description_Export_Preset_Select_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Select_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_select_required(inputs)
	if (locale === "de") return de_audio_description_export_preset_select_required(inputs)
	if (locale === "it") return it_audio_description_export_preset_select_required(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_select_required(inputs)
	if (locale === "es") return es_audio_description_export_preset_select_required(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_select_required(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_select_required(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_select_required(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_select_required(inputs)
	return en_audio_description_export_preset_select_required(inputs)
});